<template>
  <div class="Div">
    <!-- <header1></header1> -->
    <!-- 第一屏 -->
    <div
      class="InitialScreen"
      :style="'background: url('+InitialScreenCon.info.background_img+') no-repeat center;background-size: cover;height:'+height+''"
    >
      <div class="overview">
        <div
          class="title"
          @click="overviewClick()"
        >
          <span
            class="ellipsis"
            :title="InitialScreenCon.title"
          >{{InitialScreenCon.title}}</span>
         <p class="overImg el-icon-arrow-right">

          </p>
        </div>
        <div class="caption ellipsis4">
          {{InitialScreenCon.info.welcome_describe_cn}}
        </div>
        <el-button
          class="btn"
          @click="welcomeClick()"
        >{{InitialScreenCon.seeMore}}</el-button>
      </div>
      <div class="sb">
        <img
          class="sbImg"
          src="../../../static/image/shubiao.png"
          alt=""
          srcset=""
        >
        <span class="sp1"></span>
        <span class="span"></span>
      </div>
    </div>
    <!-- 头条新闻 -->
    <section class="section1">
      <div class="stitle">
        <p class="p">{{typeList[0].type_name_cn}}</p>
        <p class="p">{{typeList[0].type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <ul class="news SecNews" v-if="newsList.list.length>0">
        <li
          class="li"
          v-for="(item,i) of newsList.list"
          :key="i"
          @click="NewsDetail(item,34)"
        >
          <img
            class="newImg"
            :src="item.article_img"
            alt=""
          >
          <div class="ellipsis4 headline" :title="item.article_title_cn">
            {{item.article_title_cn}}

          </div>
        </li>
      </ul>
      <el-button
        class="more"
        @click="moreNews(typeList[0].article_type_id,34)"
      >{{newsList.seeMore}}</el-button>
    </section>
    <!-- 学术校园 -->
    <section class="section3">
      <div class="stitle">
        <p class="p">{{typeList[1].type_name_cn}}</p>
        <p class="p">{{typeList[1].type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content" v-if="newsList2.list.length>0">
        <ul class="vigorous">
          <li
            class="li"
            v-for="(item,i) of newsList2.list"
            :key='i'
            @click="NewsDetail(item,13)"
          >
            <div class="right active ">
              <img
                class="img"
                :src="item.article_img"
                alt=""
              >
              <div class="title ">
                <p
                  class="ellipsis"
                  :title="item.article_title_cn"
                >
                  {{item.article_title_cn}}
                </p>
                <p class="tcon ellipsis">
                  {{item.article_describe_cn}}
                </p>

              </div>
            </div>

          </li>
          <li class="li">
            <div
              class="right active more"
              @click="moreNews(typeList[1].article_type_id,13)"
            >
              <img
                class="img"
                :src="newsList2.background_img"
                alt=""
              >
              <div class="title">{{newsList2.seeMore}}</div>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- 活力校园 -->
    <section class="section2">
      <img
        class="back_img"
        :src="typeList[2].background_img"
        alt=""
      >
      <div class="stitle">
        <p class="p">{{typeList[2].type_name_cn}}</p>
        <p class="p">{{typeList[2].type_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi2.png"
          alt=""
        >
      </div>
      <div class="content" v-if="newsList3.list.length>0">
        <ul class="academic">
          <li
            class="li"
            v-for="(item,i) of newsList3.list"
            :key="i"
            @click="NewsDetail(item,12)"
          >

            <img
              class="img"
              :src="item.article_img"
              alt=""
            >
            <div class="divT">
              <p class="ptitle ellipsis" :title="item.article_title_cn">{{item.article_title_cn}}</p>
              <p class="legend ellipsis">{{item.article_describe_cn}}</p>
            </div>
          </li>
          <!-- <li class="li liActive">
            <img
              class="img"
              src="../../../static/image/home3-2.png"
              alt=""
            >
            <p class="title">查看更多</p>
          </li> -->
        </ul>
      </div>
      <el-button
        class="btn"
        @click="VibrantCampus(typeList[2].article_type_id)"
      >{{newsList3.seeMore}}</el-button>
    </section>
    <!-- 温馨校园 -->
    <section class="section4">
      <div class="stitle">
        <p class="p">{{warmCon.schoolTitle_cn}}</p>
        <p class="p">{{warmCon.schoolTitle_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content">
        <div
          class="leftTitle"
          ref="warmheight"
        >
          <div
            :class="warmNum==i?'text active4':'text'"
            @click="warmClick(i)"
            v-for="(item,i) of warmCon.list"
            :key="i"
          >
            <p class="p1">{{item.campus_title_cn}}</p>

            <p>{{item.campus_sketch_cn}}</p>
          </div>
        </div>
        <div
          class="rightCon"
          :style="'height:'+warmHeight"
        >
          <img
            class="img"
            :src="warmCon.list[warmNum].background_img"
            alt=""
            v-if="warmCon.list[warmNum]"
          >
          <div
            :class="warmNum==i?'contentPanel':'contentPanel animation'"
            v-for="(item,i) of warmCon.list"
            :key="i"
          >
            <p class="ellipsis4">
              {{item.campus_describe_cn}}
            </p>
            <el-button
              class="more"
              @click="warmRoute(i)"
            >{{warmCon.seeMore}}</el-button>
          </div>
        </div>
      </div>
    </section>
    <!-- 生涯规划 -->
    <section class="section5">
      <div class="stitle">
        <p class="p">{{CareerCon.classification_name.classification_name_cn}}</p>
        <p class="p">{{CareerCon.classification_name.classification_name_en}}</p>
        <img
          src="../../../static/image/zhuangshi.png"
          alt=""
        >
      </div>
      <div class="content">
        <div class="examInfor">
          <div class="left">
            <img
              :src="CareerCon.list[0].career_img"
              alt=""
            >
          </div>
          <div class="right">
            <p class="InforTitle">{{CareerCon.list[0].career_name_cn}}</p>
            <p class="expression">{{CareerCon.list[0].career_describe_cn}}</p>
            <el-button
              class="btn"
              @click="moreAdvisory(CareerCon.list[0])"
            > {{CareerCon.seeMore}}</el-button>
          </div>
        </div>
        <div class="examInfor">
          <div class="left">
            <p class="InforTitle">{{CareerCon.list[1].career_name_cn}}</p>
            <p class="expression">{{CareerCon.list[1].career_name_cn}}</p>
            <el-button
              class="btn"
              @click="moreSchool(CareerCon.list[1])"
            > {{CareerCon.seeMore}}</el-button>
          </div>
          <div class="right">
            <img
              :src="CareerCon.list[1].career_img"
              alt=""
            >
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
// import header1 from "../../layout/AppHeader";
import {
  overviewInfo,
  CampusGetLists,
  Article_type,
  ArticlegetList,
  CareerList
} from "@/api/Overview";
export default {
  name: "InnovationHighSchool",
  data() {
    return {
      height: "", //高度

      warmList: [
        {
          title: "生活篇",
          nodule: "贴心的服务",

          path: "/SchoolService"
        },
        {
          title: "共育篇",
          nodule: "加强学校与家长之间的联系",

          path: "/CoCultivation"
        },
        {
          title: "环境篇",
          nodule: "舒适的学习环境",

          path: "/GalleryDetail"
        }
      ], //温馨校园
      warmNum: 0,
      warmHeight: 559,
      vigorousNum: 1, //活力校园放大下标
      InitialScreenCon: { info: {} }, //概览
      warmCon: { list: [{ background_img: "" }] }, //温馨校园
      typeList: [{}, {}, {}], //文章分类
      newsList: { list: [{}], background_img: "" }, //头条新闻
      newsList2: { list: [{}], background_img: "" }, //学术校园
      newsList3: { list: [{}], background_img: "" }, //活力校园
      CareerCon: { classification_name: {}, list: [{}, {}] } //生涯规划
    };
  },

  computed: {
    ...mapState("user", ["headerHeight"])
  },
  // components: {
  //   header1
  // },
  methods: {
    // 监听浏览器高度宽度变化
    getHeight() {
      //   console.log(this.headerHeight, "dfsf");
      this.height = window.innerHeight - this.headerHeight + "px";
      setTimeout(() => {
        this.warmHeight = this.$refs.warmheight.offsetHeight + "px";
      }, 500);
    },
    // 温馨校园
    warmClick(item) {
      this.warmNum = item;
    },
    // 活力校园
    // 鼠标移入
    liOver(i) {
      this.vigorousNum = i;
    },
    // 鼠标移出
    liLeave() {
      this.vigorousNum = 1;
    },
    // 园所概览
    overviewClick() {
      this.$router.push({ path: "/OverviewDetailHigh",query:{uid:5} });
    },
    // 学校欢迎词
    welcomeClick() {
      this.$router.push({ path: "/Welcome", query: { sid: 5 } });
    },
    // 活力校园列表VibrantCampusList
    VibrantCampus(index) {
      var laber = [0, 5, 12, 17];
      var laPath = ["/", "/InnovationHighSchool", "/InnovationHighSchool"];
      this.$router.push({
        path: "/VibrantCampusList",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          uid: index
        }
      });
    },
    // 国际名校 FamousSchool
    moreSchool(item) {
      var laber = [0, 5,43, 21];
      var laPath = ["/", "/InnovationHighSchool", "/InnovationHighSchool"];
      this.$router.push({
        path: item.career_url,
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath)
        }
      });
    },
    // 温馨校园跳转
    warmRoute(i) {
      var laber = [0, 5];
      var laPath = ["/", "/InnovationHighSchool"];
      if (i == 2) {
        laber.push(18);
      }
      if (i == 1) {
        laber.push(23);
      }
      this.$router.push({
        path: this.warmList[i].path,
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          id: this.warmCon.album_id,
          uid: 5
        }
      });
    },
    // 跳转新闻列表
    moreNews(index,x) {
      var laber = [0, 5,x, 22];
      var laPath = ["/", "/InnovationHighSchool", "/InnovationHighSchool"];
      this.$router.push({
        path: "/NewsList",
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath),
          uid: index
        }
      });
    },
    // 新闻详情
    NewsDetail(item,x) {
      var laber = [0, 5,x, 18];
      var laPath = ["/", "/InnovationHighSchool", "/InnovationHighSchool"];
      //
      var routeData=this.$router.resolve({
        path: "/NewsDetails",
        query: {
          laber: JSON.stringify(laber),
          id: item.article_id,
          laPath: JSON.stringify(laPath)
        }
      });
      window.open(routeData.href, "_blank");
    },
    // 新闻列表
    ArticlegetLists(i, page) {
      ArticlegetList({
        article_type_id: this.typeList[i].article_type_id,
        limit: page
      }).then(res => {
        if (i == 0) {
          this.newsList = res.data;
        } else if (i == 1) {
          this.newsList2 = res.data;
        } else if (i == 2) {
          this.newsList3 = res.data;
          // console.log(this.newsList3);
        }
      });
    },
    // 生涯规划
    CareerLists() {
      CareerList({ park: 2, limit: 2 }).then(res => {
        // console.log(res.data);
        this.CareerCon = res.data;
      });
    },
    // 留学咨询
    moreAdvisory(item) {
      var laber = [0, 4,43, 22];
      var laPath = ["/", "/InnovationHighSchool", "/InnovationHighSchool"];
      this.$router.push({
        path: item.career_url,
        query: {
          laber: JSON.stringify(laber),
          laPath: JSON.stringify(laPath)
        }
      });
    }
  },
  created() {},
  mounted() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    overviewInfo({
      overview_park: 5
    }).then(res => {
      this.InitialScreenCon = res.data;
    });
    // 温馨校园
    CampusGetLists({
      park: 5
    }).then(res => {
      // console.log(res.data);
      this.warmCon = res.data;
    });
    // 文章分类 5
    Article_type({ park: 5 }).then(res => {
      // console.log(res.data);
      this.typeList = res.data;
      this.ArticlegetLists(0, 6);
      this.ArticlegetLists(1, 3);
      this.ArticlegetLists(2, 3);
    });
    this.CareerLists();
    // this.warmHeight=this.$refs.warmheight.offsetHeight+'px';
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/custom/common.scss";
.InitialScreen {
  position: relative;
  width: 100%;
  //   height: 79.5vh;
  background-size: cover;
  padding-top: 0.1px;
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 0;
    top: 0;
    left: 0;
  }
  .overview {
    position: relative;
    margin-left: 16.1%;
    margin-top: 5%;
    z-index: 1;
    text-align: left;
    .title {
      position: relative;
      font-size: px2Rem(80px);
      // font-family: "STXinwei";
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      cursor: pointer;
      span {
        vertical-align: middle;
      }
      &::before {
        display: block;
        position: absolute;
        content: "";
        width: px2Rem(100px);
        height: px2Rem(4px);
        bottom: px2Rem(-30px);
        left: px2Rem(10px);
        border-radius: 2px;
        background-color: #fff;
      }
      &:hover {
        .overImg {
          background: rgba(255, 255, 255, 0.3);
        }
      }
    }
   
    .caption {
      width: px2Rem(707px);
      height: px2Rem(175px);
      margin-top: px2Rem(70px);
      font-size: px2Rem(28px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: px2Rem(36px);
      -webkit-line-clamp: 5;
      line-clamp: 5;
    }
    .btn {
      padding: px2Rem(19px) px2Rem(68px);
      margin-top: px2Rem(60px);
      border: 2px solid rgba(255, 255, 255, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      // font-family: STXinwei;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(0, 0, 0, 0);
      transition: 0.3s;
      &:hover {
        background: rgba(255, 255, 255, 0.8);
        color: rgba(28, 50, 120, 1);
        border: 2px solid rgba(28, 50, 120, 0.1);
      }
    }
  }
}

.section1 {
  width: px2Rem(1300px);
  margin: px2Rem(60px) auto;

  .newsImg {
    display: inline-block;
    width: px2Rem(650px);
    height: px2Rem(418px);
  }
  .more {
    display: block;
    margin: px2Rem(20px) auto 0px;
    padding: px2Rem(20px) px2Rem(68);
    border: 1px solid rgba(28, 50, 120, 1);
    border-radius: 4px;
    font-size: px2Rem(24px);
    // font-family: STXinwei;
    font-weight: 400;
    color: rgba(28, 50, 120, 1);
    transition: 0.3s;
    &:hover {
      background: rgba(28, 50, 120, 0.5);
      color: #fff;
      border: 1px solid #fff;
    }
  }
}
.section2 {
  position: relative;
  padding: px2Rem(60px);
  &::before {
    display: block;
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 0;
    top: 0;
    left: 0;
  }
  .back_img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
  }
  .stitle {
    // padding-bottom: px2Rem(70px);
    .p {
      color: #fff;
      &:nth-of-type(2) {
        color: #fff;
      }
    }
  }
  .content {
    position: relative;
    width: px2Rem(1300px);
    height: px2Rem(490px);
    margin: auto;
    text-align: center;
    .academic {
      margin-top: px2Rem(35px);
      padding-bottom: px2Rem(20px);
      font-size: 0;
      .li {
        display: inline-block;
        position: relative;
        width: px2Rem(420px);
        height: px2Rem(400px);
        background: #fff;
        cursor: pointer;
        transition: 0.5s;
        font-size: 0;
        vertical-align: middle;
        top: 0;
        &:nth-of-type(2) {
          margin: 0 px2Rem(19px);
        }
        &:hover {
          top: px2Rem(-20px);
          box-shadow: 5px 5px 5px 5px rgba(0, 0, 0, 0.5);
        }
        .img {
          display: block;
          width: 100%;
          height: px2Rem(300px);
          transition: 1s;
        }
        .divT {
          width: 100%;
          height: px2Rem(100px);
          transition: 1s;
          p {
            padding: 0 px2Rem(15px);
            text-align: center;
          }
          .ptitle {
            padding-top: px2Rem(10px);
            padding-bottom: px2Rem(5px);
            font-size: px2Rem(28px);
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }
          .legend {
            font-size: px2Rem(24px);
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
  }
  .btn {
    position: relative;
    display: block;
    margin: px2Rem(30px) auto px2Rem(0px);
    width: px2Rem(220px);
    height: px2Rem(60px);
    border: 2px solid rgba(255, 255, 255, 1);
    border-radius: 4px;
    background: rgba(0, 0, 0, 0);
    font-size: px2Rem(24px);
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    transition: 0.3s;
    &:hover {
      background: rgba(255, 255, 255, 0.8);
      color: rgba(28, 50, 120, 1);
      border: 2px solid rgba(28, 50, 120, 0.1);
    }
  }
}
.section3 {
  margin-top: px2Rem(60px);
  // margin-bottom: px2Rem(60px);
  background: #f5f5f5;
  padding-bottom: 0.1px;
  .stitle {
    padding-top: px2Rem(80px);
  }
  .content {
    width: px2Rem(1300px);
    margin: px2Rem(35px) auto px2Rem(40px);
    .vigorous {
      font-size: 0;
      .li {
        display: inline-block;
        position: relative;
        width: px2Rem(620px);
        height: px2Rem(340px);
        &:nth-of-type(2n-1) {
          margin-right: px2Rem(60px);
        }
        .active {
          width: 100%;
          height: 100%;
          margin-bottom: px2Rem(40px);
          //   position: relative;
          overflow: hidden;
          cursor: pointer;
          &::before {
            display: block;
            content: "";
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: #333;

            z-index: 1;
            transition: 0.3s;
            opacity: 0;
          }
          .img {
            width: 100%;
            height: 100%;
            transition: 0.3s;
            z-index: 0;
          }
          .title {
            position: absolute;
            // width: 100%;
            top: 50%;
            left: 0;
            right: 0;
            margin: auto;
            padding: 0 px2Rem(10px);
            text-align: center;
            font-size: px2Rem(34px);
            // font-family: STXinwei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            transform: translate(0, -50%);
            transition: 0.3s;
            opacity: 0;
            z-index: 1;
            .tcon {
              margin-top: px2Rem(40px);
              font-size: px2Rem(28px);
            }
          }
          &:hover {
            .title {
              opacity: 1;
            }
            .img {
              transform: scale(1.1);
            }
            &::before {
              opacity: 0.4;
            }
          }
        }
        .more {
          .title {
            opacity: 1;
          }
          &::before {
            opacity: 0.4;
          }
        }
      }
    }
  }
}
.section4 {
  padding-top: px2Rem(60px);
  padding-bottom: px2Rem(60px);
  background: #f5f5f5;
  .content {
    width: px2Rem(1300px);
    // height: 100%;
    // border: 1px #f5f5f5 solid;
    margin: px2Rem(35px) auto 0;
    font-size: 0;
    //
    .leftTitle {
      display: inline-block;
      width: px2Rem(500px);
      .text {
        padding: px2Rem(27px) px2Rem(10px) px2Rem(42px) px2Rem(30px);
        // height: px2Rem(110px);
        background: rgba(28, 50, 120, 1);
        transition: 0.3s;
        cursor: pointer;
        &:hover {
          background: rgba(226, 187, 129, 1);
          p {
            color: rgba(51, 51, 51, 1);
          }
          .p1::after {
            background: rgba(51, 51, 51, 1);
          }
        }
        &:nth-of-type(2) {
          border-top: 2px #fff solid;
          border-bottom: 2px #fff solid;
        }
        p {
          position: relative;
          font-size: px2Rem(34px);
          // font-family: STXinwei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          &:nth-of-type(2) {
            margin-top: px2Rem(50px);
            font-size: px2Rem(28px);
            font-weight: 400;
          }
        }
        .p1::after {
          position: absolute;
          display: block;
          content: "";
          width: px2Rem(58px);
          height: px2Rem(4px);
          min-height: 2px;
          bottom: px2Rem(-15px);
          left: px2Rem(5px);
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
        }
      }
      .active4 {
        background: rgba(226, 187, 129, 1);
        p {
          color: rgba(51, 51, 51, 1);
        }
        .p1::after {
          background: rgba(51, 51, 51, 1);
        }
      }
    }
    .rightCon {
      display: inline-block;
      position: relative;
      width: px2Rem(800px);
      // height: px2Rem(540px);
      vertical-align: top;
      overflow: hidden;

      .img {
        position: absolute;
        width: 100%;
        height: 100%;
      }
      .contentPanel {
        position: absolute;
        width: px2Rem(680px);
        top: 50%;
        left: 0;
        right: 0;
        margin: auto;
        padding: 0 px2Rem(60px);
        font-size: px2Rem(28px);
        // font-family: STXinwei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        transform: translate(0, -50%);
        transition: 1s;
        p {
          line-height: px2Rem(40px);
        }
        .more {
          display: block;
          margin-top: px2Rem(50px);
          padding: px2Rem(20px) px2Rem(66px);
          border: 2px solid rgba(255, 255, 255, 1);
          border-radius: 4px;
          background: rgba(0, 0, 0, 0);
          font-size: px2Rem(24px);
          // font-family: STXinwei;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          transition: 0.3s;
          &:hover {
            background: rgba(255, 255, 255, 0.8);
            color: rgba(28, 50, 120, 1);
            border: 2px solid rgba(28, 50, 120, 0.1);
          }
        }
      }
      .animation {
        left: 150%;
        opacity: 0;
        visibility: hidden;
        transition: 0s;
      }
    }
  }
}
.section5 {
  padding-top: px2Rem(60px);
  padding-bottom: px2Rem(60px);
  .content {
    width: px2Rem(1300px);
    margin: auto;
    margin-top: px2Rem(60px);
    font-size: 0;
    text-align: center;
    .left {
      display: inline-block;
      width: px2Rem(720px);
      height: px2Rem(400px);
      vertical-align: top;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .right {
      display: inline-block;
      width: px2Rem(580px);
      height: px2Rem(400px);
    }
    .InforTitle {
      padding-top: px2Rem(95px);
      padding-bottom: px2Rem(30px);
      font-size: px2Rem(34px);
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
    .expression {
      margin-bottom: px2Rem(60px);
      font-size: px2Rem(28px);
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
    }
    .btn {
      width: px2Rem(220px);
      height: px2Rem(60px);
      border: 1px solid rgba(28, 50, 120, 1);
      border-radius: 4px;
      font-size: px2Rem(24px);
      font-weight: 400;
      color: rgba(28, 50, 120, 1);
      transition: 0.3s;
      &:hover {
        background: rgba(28, 50, 120, 0.5);
        color: #fff;
        border: 1px solid #fff;
      }
    }
  }
}
.stitle {
  position: relative;
  text-align: center;
  z-index: 1;
  .p {
    font-size: px2Rem(50px);
    // font-family: STXinwei;
    font-weight: bold;
    color: rgba(28, 50, 120, 1);
    &:nth-of-type(2) {
      padding: px2Rem(15px) 0 px2Rem(29px);
      font-size: px2Rem(24px);
      font-family: Arial;
      font-weight: 400;
      color: rgba(205, 205, 205, 1);
    }
  }
  > img {
    width: px2Rem(28);
    height: px2Rem(28);
  }
}
.Div {
  font-family: "STXinwei";
}
button {
  font-family: "STXinwei";
}
.title {
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/views/InnovationHighSchool/Index.vue